const auth = {
  login: 'Login'
};

export default auth;
